import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import TeamsContainer from './TeamsContainer'


const TeamsRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><TeamsContainer></TeamsContainer></Provider>
}

TeamsRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default TeamsRoot
